



<!--     *********     FEATURES 3      *********      -->
<div class="features-66">
  <div class="container">



    <div class="row">
      <div class="col-md-7">
        <div class="row">
          <div class="container">
            <h3 class="title">A Complete END-TO-END Solution for Healthcare Professionals</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="info info-horizontal">
              <div class="icon icon-primary">
                <i class="nc-icon nc-ambulance"></i>
              </div>
              <div class="description">
                <h4 class="info-title">Practice Management Software</h4>
                <p>Our software is tailor-made to assist healthcare providers with running their practices efficiently
                  and effectively, leaving the practitioners free to take care of their patients. Our simple user
                  interface allows patient files to be easily accessed with comprehensive electronic medical records.
                </p>
                <p>Our billing system integrates with all major medical aids, assuring our clients that their claims
                  will be processed successfully in real-time. Our advanced Clinical Notes functionality enables
                  healthcare providers to capture all interactions wherever they are. In addition to that, our Clinical
                  Notes feature has built-in artificial intelligence to assist in making precision diagnosis and
                  treatment decisions.</p>

              </div>
            </div>




            <div class="info info-horizontal">
              <div class="icon icon-danger">
                <i class="fa fa-mobile" aria-hidden="true"></i>
              </div>
              <div class="description">
                <h4 class="info-title">Mobile Web Application</h4>
                <p>With our new web based mobile App you will have a birds eye view of exactly what is transpiring in
                  your practice at any given time and from any mobile device anywhere in the world, 24/7.</p>

              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-danger">
                <i class="fa fa-credit-card" aria-hidden="true"></i>
              </div>
              <div class="description">
                <h4 class="info-title">Medical Debt Management</h4>
                <p>Our dedicated collections specialists are equipped to provide an unmatched level of service. Using
                  ageing reports, and monthly status reviews, we customize your collections process so it’s quicker,
                  easier, and most importantly, recovering your money.</p>

              </div>
            </div>

          </div>
          <div class="col-md-6">


            <div class="info info-horizontal">
              <div class="icon icon-primary">
                <i class="nc-icon nc-paper"></i>
              </div>
              <div class="description">
                <h4 class="info-title">Clinical Notes
                  on <img class="mt-1" alt="" style="max-height: 20px ;" src="./assets/img/brand/eMD_Cloud.png"></h4>


                <p>

                  Improved Clinical Notes and Electronic Medical Records (EMR) with built-in AI are now available on our
                  cloud application. This system feature allows the Healthcare Provider to create accurate
                  electronic clinical notes of a patient’s medical history, diagnosis, treatment and care.
                </p>






              </div>
            </div>



            <div class="info info-horizontal">
              <div class="icon icon-primary">
                <i class="fa fa-recycle" aria-hidden="true"></i>
              </div>
              <div class="description">
                <h4 class="info-title">Paperless Solutions</h4>
                <p>We strategically developed our software to be accessible from any device. All our records are
                  electronically securely stored and encrypted. We are also POPIA compliant, which means that your
                  patient data is protected. Everything you need to run a successful practice is available in our
                  software.
                </p>

              </div>
            </div>

            <div class="info info-horizontal">
              <div class="icon icon-primary">
                <i class="fa fa-hand-pointer-o" aria-hidden="true"></i>
              </div>
              <div class="description">
                <h4 class="info-title">eScript</h4>
                <p>Our e-Script feature in partnership with Dis-Chem allows Healthcare Providers to submit prescriptions
                  in real-time to the Pharmacy while creating a claim. Not only does it save time, but it’s also
                  convenient for patients not having to stand in the long queues. Patients also have the option to have
                  their prescriptions delivered.</p>

              </div>
            </div>



          </div>


        </div>
      </div>
      <div class="col-md-5 ml-auto mr-auto text-center">


        <div class="iphone-container mt-5">


          <img class="mt-1 w-100" alt="" src="./assets/img/brand/eMD_Cloud.png">


        </div>


        <div class="iphone-container mt-5">
          <a href="https://www.doctorsnearme.co.za/index" class="nav-link">

            <img class="mt-1 w-100" alt="" src="./assets/img/brand/doctorsnearme2.png">

          </a>
        </div>
        <div class="iphone-container mt-5">

          <img class="mt-1 w-100" alt="" src="./assets/img/brand/eScript.png">


        </div>


        <div class="iphone-container mt-5">
          <img src="./assets/img/brand/e-AI_logo.png" />
        </div>

        <h5 class="info-title mt-5">Trusted by over</h5>
        <div class="iphone-container mt-4">
          <img src="./assets/img/brand/3000.png" />
        </div>
        <h5 class="info-title mt-4">practices and over</h5>
        <div class="iphone-container mt-4">
          <img src="./assets/img/brand/87.png" />
        </div>
        <h5 class="info-title mt-4">different provider types.</h5>



      </div>
    </div>
  </div>
</div>





<!--     *********     FEATURES 3      *********      -->

<div class="features-3 section-gray mt-n5">
  <div class="container">






    <div class="row">


      <!-- <div class="col-md-5 ml-auto mr-auto text-center justify-content-center align-items-center">
        <div class="row">
          <div class="container">
            <h3 class="title">More of Our Services and Integration Options...</h3>
          </div>
        </div>
        
      </div> -->

      <div class="col-md-12">

        <div class="row">




          <div class="col-md-4">

            <div class="info info-horizontal">
              <div class="icon icon-warning">
                <i class="nc-icon nc-www"></i>
              </div>
              <div class="description">



                <a href="https://www.doctorsnearme.co.za/index">

                  <img class="mt-1 mb-5" style="max-height: 50px;" alt="" src="./assets/img/brand/doctorsnearme2.png">

                </a>


                <p>Find doctors near you:</p>

                <p>Healthcare Providers</p>
                <ul>
                  <li>Virtual tel-e-consults®</li>
                  <li>Online Calendar</li>
                  <li>Promote your Practice</li>
                  <li>Visit www.doctorsnearme.co.za
                    to register</li>
                  <li>Personalized practice website to
                    assist in bookings and visibility</li>
                </ul>
                <p>Patients</p>
                <ul>
                  <li>Comprehensive Electronic Medical Records</li>

                  <li>Medical History</li>
                  <li>Pathology Results with Graphs</li>
                  <li>Online Medical Appointments</li>


                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-4">





            <div class="info info-horizontal">
              <div class="icon icon-warning">
                <i class="nc-icon nc-www"></i>
              </div>
              <div class="description">





                <img class="mt-1 mb-4" style="max-height: 75px;" alt="" src="./assets/img/brand/e-AI_logo.png">



                <p>This new AI-powered feature will assist in making precision diagnosis and treatment decisions.</p>


                <ul>
                  <li>Precision diagnosis and treatment</li>
                  <li>Instant diagnosis saves time</li>
                  <li>Improved treatment plans</li>
                  <li>Comprehensive Differential Diagnosis</li>
                  <li>Access to much more Clinical information</li>
                  <li>Letters</li>
                  <li>Drug Interaction</li>
                  <li>Contraindications</li>
                  <li>e-AI Assistant</li>

                  <li>Additional features launching soon...</li>
                </ul>
              </div>
            </div>





          </div>

          <div class="col-md-4">

            <div class="info info-horizontal">
              <div class="icon icon-warning">
                <i class="nc-icon nc-www"></i>
              </div>
              <div class="description">


                <img class="mt-1 mb-5" style="max-height: 50px;" alt="" src="./assets/img/brand/eScript.png">

                <p>e-Scripting will assist doctors in creating a script electronically while creating a claim and
                  submitting it in real-time to Dischem.</p>
                <ul>
                  <li>Real-time prescriptions to the Pharmacy</li>
                  <li>Saves time by skipping the long queues</li>
                  <li>Convenient as prescriptions can be delivered</li>

                </ul>
                <h5 class="info-title mb-4 mt-4"> <strong> in collaboration with </strong> </h5>
                <a href="https://www.dischem.co.za/" target="_blank">
                  <img class="img img-responsive" src="./assets/img/brand/Dis-Chem.png" style="width: 50%;">
                </a>

              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>



<!--     *********     FEATURES 3      *********      -->
<div class="features-3 mt-n5">
  <div class="container">
    <div class="row">

      <div class="col-md-7" id="ref_pms">
        <div class="row">
          <div class="container">
            <h3 class="title">Practice Management Software</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="info-horizontal">
              <div class="icon icon-primary">
                <i class="nc-icon nc-ambulance"></i>
              </div>
              <div class="description">

                <p>We embed our software
                  with best practices derived
                  from millions of encounters
                  and deep collaboration with the
                  best run Healthcare practices.</p>

              </div>
            </div>
            <div class="info-horizontal col-md-12">
              <div class="description col-md-12 ">

                <div class="row col-md-12">
                  <div class="col-md-6">
                    <ul class="info">



                      <li>Automated Pathology Reports</li>
                      <li>Bulk SMS</li>
                      <li>Clinical Notes </li>
                      <li>Cloud Application </li>
                      <li>Electronic Data Interchange (EDI)</li>
                      <li>Electronic Medical Records </li>
                      <li>Electronic Remittance Advice</li>
                      <li>Electronic Switching </li>
                      <li>eScript: Electronic Prescriptions</li>
                      <li>Healthcare Advisory </li>
                      <li>Healthcare IT Consulting </li>
                      <li>Medical Billing</li>
                      <li>Medical Debt Management </li>







                    </ul>
                  </div>
                  <div class="col-md-6">


                    <ul class="info">

                      <li>Mobile Web App</li>
                      <li>Paediatric Graphs </li>
                      <li>Paperless Solution </li>
                      <li>Pathology Results </li>
                      <li>Patient Clinical Records</li>
                      <li>Patient Debt Recovery </li>
                      <li>Patient Family Check</li>
                      <li>Practice Management Application</li>
                      <li>Real-time Benefit Checks</li>
                      <li>Real-time Claims</li>
                      <li>Tariff Coding and Pricing</li>
                      <li>Training Services </li>
                      <li>Virtual Consultations</li>

                    </ul>
                  </div>

                </div>

              </div>
            </div>
          </div>




        </div>
      </div>

      <div class="col-md-5 ml-auto mr-auto text-center">
        <h5 class="info-title">Standalone Technology</h5>
        <div class="iphone-container">
          <img src="./assets/img/brand/other/debt_recovery.png" />
        </div>
        <h5 class="info-title">Calendar Sync</h5>
        <div class="iphone-container">
          <img src="./assets/img/brand/other/calendar.png" />
        </div>



      </div>

    </div>
  </div>
</div>









<!--     *********     FEATURES 3      *********      -->
<div class="features-3 section-gray" id="ref_cn">
  <div class="container section-gray">
    <div class="row">

      <div class="col-md-5 ml-auto mr-auto text-center">
        <h5 class="info-title mb-5"></h5>
        <div class="iphone-container">
          <img src="./assets/img/brand/icons/007a.png" />
        </div>

      </div>
      <div class="col-md-7">
        <div class="row">
          <div class="container">
            <h3 class="title">Clinical Notes
              on <img class="" alt="" style="max-height: 25px ;" src="./assets/img/brand/eMD_Cloud.png"></h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="info-horizontal">
              <div class="icon icon-primary">
                <i class="nc-icon nc-ambulance"></i>
              </div>
              <div class="description">

                <p> Improved Clinical Notes and Electronic Medical Records (EMR) are now available on our cloud
                  application.
                  This system feature allows the Healthcare Provider to create accurate electronic clinical notes of a
                  patient’s medical history, diagnosis, treatment and care.
                </p>

              </div>
            </div>
            <div class="info-horizontal col-md-12">
              <div class="description col-md-12 ">

                <div class="row col-md-12">
                  <div class="col-md-6">
                    <ul class="info">
                      <li>Medical History</li>
                      <li>Main Complaint</li>
                      <li>Examination</li>
                      <li>Vital Signs</li>
                      <li>Investigations</li>
                      <li>Graphs</li>
                      <li>Assessment</li>
                      <li>Attachments</li>

                    </ul>
                  </div>
                  <div class="col-md-6">


                    <ul class="info">

                      <li>Plan</li>
                      <li>Treatment</li>
                      <li>Attachments</li>
                      <li>Electronic Patient Consent</li>
                      <li>Graphically Represented Clinical Results</li>
                      <li>Pathology Results</li>
                      <li>e-AI</li>
                    </ul>
                  </div>

                </div>

              </div>
            </div>
          </div>




        </div>
      </div>




    </div>
  </div>
</div>






<!--     *********     FEATURES 4     *********      -->
<div class="features-3 mt-n5" id="ref_rtcp">
  <div class="container">
    <div class="row">
      <div class="col-md-8 ml-auto mr-auto text-center">
        <h3 class="title">Real-time Claims Processing</h3>
        <h5 class="description">Submit your claims in real-time to all major Medical Aids and get instant feedback with
          detailed response information.</h5>
      </div>
    </div>
    <div class="row">


      <div class="col-md-6 offset-1">
        <div class="info info-horizontal">
          <div class="icon icon-primary">
            <i class="nc-icon nc-bank" aria-hidden="true"></i>
          </div>
          <div class="description">
            <h4 class="info-title">Benefits</h4>
            <p>Virtual claims with member validation and benefit checking before submission.</p>
          </div>
        </div>

        <div class="info info-horizontal">
          <div class="icon icon-primary">
            <i class="nc-icon nc-bell-55" aria-hidden="true"></i>
          </div>
          <div class="description">
            <h4 class="info-title">Local</h4>
            <p>No internet, no problem. Our system allows you to still see patients and continue to work locally.</p>
          </div>
        </div>
        <div class="info info-horizontal">
          <div class="icon icon-primary">
            <i class="nc-icon nc-credit-card" aria-hidden="true"></i>
          </div>
          <div class="description">
            <h4 class="info-title">Electronic Submissions</h4>
            <p>Electronic Data Interchange (EDI) - Electronic Submission of claims</p>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="ipad-container">
          <img style="height: 230px;" src="./assets/img/brand/icons/012a.png" />
        </div>

        <div class="ipad-container">
          <img style="height: 230px;" src="./assets/img/brand/icons/011a.png" />
        </div>

      </div>

    </div>
  </div>
</div>
